import { createSlice } from "@reduxjs/toolkit";

const consultSlice = createSlice({
  name: "consult",
  initialState: {
    searchColumns: [],
    searchEditColumns: [],
    colSelected: [],
    colSelectEdit: [],
    templateEdit: [],
    editTemplate: false,
    cloneTemplate: false,
  },
  reducers: {
    setSearchColumns: (state, action) => {
      state.searchColumns = action.payload;
    },
    setSearchEditColumns: (state, action) => {
      state.searchEditColumns = action.payload;
    },
    setColSelected: (state, action) => {
      state.colSelected = action.payload;
    },
    setColSelectEdit: (state, action) => {
      state.colSelectEdit = action.payload;
    },
    setTemplateEdit: (state, action) => {
      state.templateEdit = action.payload;
    },
    setEditTemplate: (state, action) => {
      state.editTemplate = action.payload;
    },
    setCloneTemplate: (state, action) => {
      state.cloneTemplate = action.payload;
    },
    resetColSelectEdit: (state) => {
      state.colSelectEdit = [];
    },
    resetConsult: (state) => {
      state.colSelected = [];
      state.colSelectEdit = [];
    },
  },
});

export const {
  setSearchColumns,
  setSearchEditColumns,
  setColSelected,
  setColSelectEdit,
  setTemplateEdit,
  setEditTemplate,
  setCloneTemplate,
  resetColSelectEdit,
  resetConsult,
} = consultSlice.actions;

export default consultSlice.reducer;

//Columnas para la busqueda
export const getSearchColumns = (state) => {
  return state.consult.searchColumns;
};

//Listado de columnas a editar
export const getSearchEditColumns = (state) => {
  return state.consult.searchEditColumns;
};

//Columnas Seleccionadas
export const getColSelected = (state) => {
  return state.consult.colSelected;
};

//Columnas seleccionadas Editar
export const getColSelectEdit = (state) => {
  return state.consult.colSelectEdit;
};

//Plantilla a Editar
export const getTemplateEdit = (state) => {
  return state.consult.templateEdit;
};

//Bandera Editar Plantilla
export const getEditTemplate = (state) => {
  return state.consult.editTemplate;
};

//Plantilla a Clonar
export const getCloneTemplate = (state) => {
  return state.consult.cloneTemplate;
};
